const eyesElements = document.querySelectorAll('.js-eyes');

if (eyesElements.length) {
  let mx = window.innerWidth / 2, my = window.innerHeight / 2;
  let px = mx, py = my;

  document.addEventListener('mousemove', e => {
    mx = e.clientX;
    my = e.clientY;
  });

  const clamp = (v, min, max) => Math.max(min, Math.min(max, v));
  const lerp = (a, b, n) => a + (b - a) * n;

  (function loop() {
    px = lerp(px, mx, 0.15);
    py = lerp(py, my, 0.15);

    eyesElements.forEach(eyes => {
      const pupils = eyes.querySelectorAll('path[fill="#000"]');
      if (!pupils.length) return;

      const eyesRect = eyes.getBoundingClientRect();

      pupils.forEach(p => {
        const b = p.getBBox();
        const cx = b.x + b.width / 2;
        const cy = b.y + b.height / 2;

        const eyeCenterX = eyesRect.left + cx;
        const eyeCenterY = eyesRect.top + cy;

        const dx = (px - eyeCenterX) * 0.06;
        const dy = (py - eyeCenterY) * 0.06;

        p.setAttribute(
          'transform',
          `translate(${clamp(dx, -5, 5)} ${clamp(dy, -4, 4)})`
        );
      });
    });

    requestAnimationFrame(loop);
  })();
}
